export const TERMINAL_EXTRACTION_STATUSES = ['completed', 'failed'];
